<ng-container *ngIf="srsButtonToggle$ | async">
  <div class="button">
    <sh-button
      [icon]="icon$ | async"
      icon-position="left"
      label="{{
        (trigger.loading$ | async)
          ? ('label.srsRefreshButton.collecting' | translate)
          : ('label.srsRefreshButton.text' | translate)
      }}"
      color="secondary"
      size="xl"
      (click)="triggerDataCollection()"
      [disabled]="pmService.srsTriggerCollection.loading$ | async"
    >
    </sh-button>
    <div class="spinner" *ngIf="trigger.loading$ | async">
      <sh-spinner size="s"></sh-spinner>
    </div>
  </div>
  <sh-text color="secondary">
    <span class="error" *ngIf="error$ | async">{{ error$ | async }}</span>
    <ng-container *ngIf="srsLastTriggerTimeDisplay$ | async"
      >Last collection of platform messages:
      <i>{{ srsLastTriggerTimeDisplay$ | async }}.</i>
    </ng-container>
    (Data collection takes time. Come back later and check the "Last Update"
    time of XMART to see results.)
  </sh-text>
</ng-container>
